// extracted by mini-css-extract-plugin
export default {"root":"UserInfo_root__i-Og3","dropdown":"UserInfo_dropdown__yV604"};